import ReceivedRequestsTable from './ReceivedRequestsTable'

export default ReceivedRequestsTable
